var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Anime-error" }, [
    _c("div", { staticClass: "Anime-error__thumbnail" }, [
      _c("img", { attrs: { src: _vm.oups, alt: "error-thumbnail" } }),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Anime-error__message" }, [
      _c("h2", [_vm._v("Oups! An error ocurred")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }